import React, { useEffect, useState } from 'react';
import { WarehouseExtraServiceDataForm } from '../../../../../../../app/models/WareHouseQuoteExtraService';
import { Currency } from '../../../../../../../app/models/Currency';
import { Unit } from '../../../../../../../app/models/Unit';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../../../../components/SelectTwo';
import { Service, ServiceDataForm } from '../../../../../../../app/models/Service';
import useHandleErrorFields from '../../../../../../../hooks/useHandleErrorFields';
import { ItemCategory } from '../../../../../../../app/models/ItemCategory';
import { Sector } from '../../../../../../../app/models/Sector';

interface Props {
    extraServiceForm: WarehouseExtraServiceDataForm;
    setExtraServiceForm: (form: WarehouseExtraServiceDataForm) => void;
    currencies: Currency[];
    errorFields?: any;
    units: Unit[];
    services: ServiceDataForm[];
    itemCategories: ItemCategory[];
    disabled?: boolean;
    disabledEdit?: boolean;
    onCreateService?: () => void;
}

const WarehouseExtraServiceForm = ({
    extraServiceForm,
    setExtraServiceForm,
    errorFields,
    currencies,
    units,
    itemCategories,
    services,
    disabled = false,
    disabledEdit = false
}: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    const [filteredItemCategories, setFilteredItemCategories] = useState<ItemCategory[]>([]);
    const [filteredServices, setFilteredServices] = useState<ServiceDataForm[]>([]);

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    useEffect(() => {
        if ( extraServiceForm.item_category_id) {
            const filtered = services.filter(
                (s) =>
                    s.item_category_id === extraServiceForm.item_category_id 
                    // s.sector_id === extraServiceForm.sector_id
            );
            setFilteredServices(filtered);
            setExtraServiceForm({
                ...extraServiceForm,
                service_id: 0
            });
        } else {
            setFilteredServices([]);
        }
    }, [extraServiceForm.item_category_id]);
    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setExtraServiceForm({ ...extraServiceForm, [name]: value });
    };

    const handleChangeSelectTwo = (field: string, value: number | string) => {
        setExtraServiceForm({ ...extraServiceForm, [field]: value });
    };

    return (
        <>
            {/* <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Sector</label>
                    <SelectTwo
                        name="sector_id"
                        id="sector_id"
                        inputValue={extraServiceForm.sector_id}
                        onChange={(value: any) => handleChangeSelectTwo('sector_id', value?.value)}
                        options={SelectTwoMapperOptions(sectors)}
                        hasError={fieldHasError('sector_id') !== ''}
                        placeholder="Seleccione sector"
                        onFocus={() => onFocusRemove('sector_id')}
                    />
                    <div className="invalid-feedback">{fieldErrorMessage('sector_id')}</div>
                </div>
            </div> */}

            {/* <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Categoría</label>
                    <SelectTwo
                        name="item_category_id"
                        id="item_category_id"
                        inputValue={extraServiceForm.item_category_id}
                        onChange={(value: any) =>
                            handleChangeSelectTwo('item_category_id', value?.value)
                        }
                        options={SelectTwoMapperOptions(itemCategories, 'id', ['name'])}
                        hasError={fieldHasError('item_category_id') !== ''}
                        placeholder="Seleccione categoría"
                        onFocus={() => onFocusRemove('item_category_id')}
                    />
                    <div className="invalid-feedback">{fieldErrorMessage('item_category_id')}</div>
                </div>
            </div> */}

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Servicio adicional</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="service_id"
                        id="service_id"
                        hasError={fieldHasError('service_id') !== ''}
                        inputValue={extraServiceForm.service_id}
                        options={SelectTwoMapperOptions(services, 'id', ['name'])}
                        onChange={(value: any) =>
                            handleChangeSelectTwo('service_id', value?.value)
                        }
                        placeholder="Seleccione un servicio"
                        disabled={disabled}
                        onFocus={() => onFocusRemove('service_id')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                    {fieldErrorMessage('service_id')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Precio</label>
                <div className="col-md-9">
                    <div className="row g-1">
                        <div className="col-6">
                            <input
                                type="number"
                                name="price"
                                className={`form-control ${fieldHasError('price')}`}
                                value={extraServiceForm.price ?? ''}
                                onChange={handleChange}
                                placeholder="Valor"
                                disabled={disabled}
                                onFocus={() => onFocusRemove('price')}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                            {fieldErrorMessage('price')}
                            </div>
                        </div>
                        <div className="col-3">
                            <SelectTwo
                                name="currency_id"
                                id="currency_id"
                                inputValue={extraServiceForm.currency_id}
                                options={SelectTwoMapperOptions(currencies, 'id', ['name'])}
                                hasError={fieldHasError('currency_id') !== ''}
                                onChange={(opt: any) =>
                                    handleChangeSelectTwo('currency_id', opt.value)
                                }
                                placeholder="Moneda"
                                disabled={disabled}
                                onFocus={() => onFocusRemove('currency_id')}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('currency_id')}
                            </div>
                        </div>
                        <div className="col-3">
                            <SelectTwo
                                name="unit_id"
                                id="unit_id"
                                inputValue={extraServiceForm.unit_id}
                                options={SelectTwoMapperOptions(units, 'id', ['name'])}
                                hasError={fieldHasError('unit_id') !== ''}
                                onChange={(opt: any) =>
                                    handleChangeSelectTwo('unit_id', opt.value)
                                }
                                placeholder="Unidad"
                                disabled={disabled}
                                onFocus={() => onFocusRemove('unit_id')}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('unit_id')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WarehouseExtraServiceForm;
